














































































































































import { Component, Vue } from 'vue-property-decorator';
import ActivityList from '@/components/documents/ActivityList.vue';
import AddDirectoryModal from '@/components/documents/AddDirectoryModal.vue';
import DirectoryCardList from '@/components/documents/DirectoryCardList.vue';
import DirectoryTable from '@/components/documents/DirectoryTable.vue';
import EachActivityList from '@/components/documents/EachActivityList.vue';
import { Directories, ActivityHistories } from '@/@types/LibraryComponent';

@Component({
  components: {
    ActivityList,
    AddDirectoryModal,
    DirectoryCardList,
    DirectoryTable,
    EachActivityList,
  },
})
export default class DocumentsBase extends Vue {
  private isOpenAddDirectoryModal: boolean = false;
  private directoryCount: number = 11;

  private viewFlag: {
    isCardView: boolean;
    isListView: boolean;
    isActivityView: boolean;
    isEachActivityView: boolean;
  } = { isCardView: true, isListView: false, isActivityView: true, isEachActivityView: false };
  private changeIndex: { directoryIndex: number; activityIndex: number } = {
    directoryIndex: 0,
    activityIndex: 2,
  };
  private componentIndex: {
    directoryCard: number;
    directoryTable: number;
    activityList: number;
    eachActivityList: number;
  } = {
    directoryCard: 0,
    directoryTable: 1,
    activityList: 2,
    eachActivityList: 3,
  };

  private componentTypes = [DirectoryCardList, DirectoryTable, ActivityList, EachActivityList];
  private directories: Array<Directories> = [
    {
      name: '案件一覧画面設計内部あああああ用',
    },
    {
      name: '案件一覧画面設計',
    },
    {
      name: '案件一覧画面設計',
    },
    {
      name: '案件一覧画面設計',
    },
    {
      name: '案件一覧画面設計',
    },
    {
      name: '案件一覧画面設計',
    },
    {
      name: '案件一覧画面設計',
    },
    {
      name: '案件一覧画面設計',
    },
    {
      name: '案件一覧画面設計',
    },
    {
      name: '案件一覧画面設計',
    },
    {
      name: '案件一覧画面設計',
    },
    {
      name: '案件一覧画面設計',
    },
    {
      name: '案件一覧画面設計',
    },
  ];

  private activityHistories: Array<ActivityHistories> = [
    {
      title: 'ページタイトル',
      subtitle: '案件一覧画面設計',
      userName: 'セオリーA太郎',
    },
    {
      title: 'ページサブタイトル',
      subtitle: '案件一覧画面設計',
      userName: 'セオリーA太郎',
    },
    {
      title: 'ページタイトル2',
      subtitle: '案件一覧画面設計',
      userName: 'セオリーB太郎',
    },
    {
      title: 'ページタイトル3',
      subtitle: '案件一覧画面設計',
      userName: 'セオリーC太郎',
    },
  ];

  private eachActivityHistories: Array<ActivityHistories> = [
    {
      title: 'ページタイトル',
      subtitle: '案件一覧画面設計',
      userName: 'セオリーA太郎',
    },
    {
      title: 'ページサブタイトル',
      subtitle: '案件一覧画面設計',
      userName: 'セオリーA太郎',
    },
  ];

  private histories: Array<ActivityHistories> = [
    { title: 'ページタイトル', subtitle: '案件一覧画面設計' },
    { title: 'ページタイトル2', subtitle: '案件一覧画面設計' },
    { title: 'ページタイトル3', subtitle: '案件一覧画面設計' },
  ];

  private viewIconColor(isView: boolean): '#4384f3' | 'grey lighten-1' {
    if (isView) {
      return '#4384f3';
    } else {
      return 'grey lighten-1';
    }
  }

  private returnDirectories(): Array<Directories> {
    // dataのlistプロパティからdirectoryCountプロパティ設定分に絞る
    return this.directories.slice(0, this.directoryCount);
  }

  private returnActivityHistories(): Array<ActivityHistories> | undefined {
    const displayActivityHistories = this.activityHistories;
    const displayEachActivityHistories = this.eachActivityHistories;
    if (this.changeIndex.activityIndex === 2) {
      return displayActivityHistories;
    } else if (this.changeIndex.activityIndex === 3) {
      return displayEachActivityHistories;
    } else return;
  }
  // ディレクトリの詳細画面に遷移する
  private showDocument(): void {
    this.$router.push({ name: 'documents2' });
  }

  private isMore(): void {
    this.directoryCount = this.directories.length;
  }

  private closeAddDirectoryModal(): void {
    this.isOpenAddDirectoryModal = false;
  }

  // アイコンのクリックでディレクトリ表示を切り替える
  private onChangeDirectory(index: number): void {
    const directoryIndex: number = this.changeIndex.directoryIndex;
    if (directoryIndex !== index) {
      this.changeIndex.directoryIndex = index;

      if (index === 0) {
        this.viewFlag.isCardView = true;
        this.viewFlag.isListView = false;
      } else {
        this.viewFlag.isCardView = false;
        this.viewFlag.isListView = true;
      }
    }
  }
  // アイコンのクリックでアクティビティ表示を切り替える
  private onChangeActivity(index: number): void {
    const activityIndex = this.changeIndex.activityIndex;
    if (activityIndex !== index) {
      this.changeIndex.activityIndex = index;

      if (index === 2) {
        this.viewFlag.isActivityView = true;
        this.viewFlag.isEachActivityView = false;
      } else {
        this.viewFlag.isActivityView = false;
        this.viewFlag.isEachActivityView = true;
      }
    }
  }
  // 表示されるディレクトリのコンポーネントを取得
  private get directoryComponent(): {} | void {
    const index = this.changeIndex.directoryIndex;
    if (index !== -1) {
      return this.componentTypes[index];
    } else return;
  }
  // 表示されるアクティビティのコンポーネントを取得
  private get activityComponent(): {} | void {
    const index = this.changeIndex.activityIndex;
    if (index !== -1) {
      return this.componentTypes[index];
    } else return;
  }
}
